import { breakpoints, theme } from "@shapeable/theme";
import { ThemeOverrides } from "@shapeable/types";
import { css } from "styled-components";

export const YELLOW = '#FFCA04';
export const YELLOW_DARK = '#FCB10F';
export const YELLOW_ORANGE = '#F79616';
export const BEAUTIFUL_BUFF = '#F2EAE2';

export const FC_YELLOW = '#FFB000';

export const DARKER_PRIMARY = '#F79616FF';

export const themeOverrides: ThemeOverrides = {
  font: {
    family: {
      heading: `'Host Grotesk', sans-serif`,
      serif: `'Host Grotesk', serif`,
      sans: `'Host Grotesk', sans-serif`,
    },
  },
  light: {
    color: {
      
      appChrome: '#F2EAE2',

      darkBackground: '#202124',
      lightBackground: '#F8F8F8',
  
      midBrand: YELLOW_DARK,
      primary: YELLOW_DARK,
  
  
      // linkHover: ORANGE,
      link: FC_YELLOW,
      // linkInvertedHover: YELLOW,
      // linkActive: YELLOW,
  
      // menuItemLinkHover: YELLOW_DARK, 
      // menuItemLinkActive: YELLOW_DARK, 
      // invertedMenuItemLinkHover: YELLOW_DARK, 
  
    },
  },
};


/* 
--------------------

  Layout Styles
  
  NB: This is the appropriate place to override styling for this specific site, based on BEM-style class name targets 
  
--------------------
*/

export const LayoutStyles = breakpoints({
  base: css`

    .link-override {
      color: ${theme.COLOR('primary')};
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      flex-direction: column;
      gap: 0.25em;

      h1 {
        align-self: flex-start;
      }
    }

    .shp--slice-intro {
      font-size: 1.75em;
      text-align: left;
      line-height: 1.25em;
    }

    .shp--slice-key-message {
      .shp--content {
        line-height: 1.10em;
        font-family: ${theme.FONT('sans')};
        font-weight: 400;
      }
    }

    .shp--slice-layout-content-with-image {
      .shp--content-node {
        color: ${theme.COLOR('inherit')};
      }
      li::before {
        color: ${theme.COLOR('inherit')};
      }
    }

    #customers .shp--button {
      color: ${theme.COLOR('light')};
      ${theme.FILL('light')};
      border: 2px dotted ${theme.COLOR('light')};
      &:hover {
        color: ${theme.COLOR('#FCB10F')};
        ${theme.FILL('#FCB10F')};
        border: 2px dotted ${theme.COLOR('#FCB10F')};
      }
    }

    .shp--slice-layout-organisations {
      .shp--slice-organisations__organisations {
        justify-content: center;
      }
    }

    // Recently added styles for the site ----------

    .shp--site-header-utility-button__button {
      color: ${theme.COLOR('dark')};
      ${theme.FILL('dark')};
    }

    .shp--site-header-layout {
      background: ${BEAUTIFUL_BUFF};
    }

    .shp--slice-section-color-block__body {
      .shp--button {
        color: ${theme.COLOR('dark')};
        ${theme.FILL('dark')};
        border-color: ${theme.COLOR('dark')};
      }
    }
    
    .shp--slice-inset-image-block {
      .shp--content-entity-block__content {
        font-size: 1.13em;
      }
      .shp--content-entity-block__buttons {
        margin-top: 42px;
      }
      h1 {
        font-weight: 700;
      }
    }

    .shp--slice-header {
      font-weight: 700;
    }

    .shp--slice-latest-insights {
      .shp--slice-header {
        text-align: left;
      }
    }

    .shp--slice-banner-tout {

      .shp--slice-banner-tout__body {
        max-width: 650px;
      }

      .shp--slice-banner-tout__title {
        font-weight: 800;
        font-size: 2.8em;
        line-height: 0.9em;

        strong, b {
          font-weight: 800;
          color: inherit;
        }
      }
    }
    .shp--slice-layout-contact-form {
      .shp--field__label {
        text-transform: none;
      }
    }

    .shp--content {
      strong {
        color: ${theme.COLOR('dark')};
      }
    }

  `,
  tablet: css`
    .shp--slice-intro {
      font-size: 2em;
      text-align: left;
      line-height: 1.25em;
    }

  .shp--slice-banner-tout {
      .shp--slice-banner-tout__title {
        font-size: 4em;
      }
    }

  `,
  desktop: css`
    .shp--slice-section-color-block {
      min-height: 600px;
    }

    .page-home .shp--page-layout-standard__banner-titles div div {
      gap: 1em;
    }

    
    
  `,
});